export class AdditionalGuestRestriction {
  body: string;
  header: string;

  constructor (body: string, header: string) {
    this.body = body;
    this.header = header;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/additional-guest-restriction.model.ts